export enum SliderTitles {
  LEARN_MORE = 'Més informació',
  LANDSCAPES_BTN = 'Paisatges captivadors de Catalunya',
  CATALUNYA = ' Catalunya',
}
